import { render } from "./MainCanvas.vue?vue&type=template&id=bf040d48&scoped=true"
import script from "./MainCanvas.vue?vue&type=script&lang=js"
export * from "./MainCanvas.vue?vue&type=script&lang=js"

import "./MainCanvas.vue?vue&type=style&index=0&id=bf040d48&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf040d48"]])

export default __exports__